import script from "./InventorySlideshow.vue?vue&type=script&setup=true&lang=js"
export * from "./InventorySlideshow.vue?vue&type=script&setup=true&lang=js"

import "./InventorySlideshow.vue?vue&type=style&index=0&id=512bcc9f&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512bcc9f"]])

export default __exports__